import { Store } from 'vuex'
import { AxiosError, AxiosInstance } from 'axios'
import { State as StoreState } from '@/store/index'
import { instanceNoAuth } from '@/model/api/apibase'
import { ErrorResponse } from '@/model/api/error/erroResponse'
import { ErrorMsgState } from '@/model/components/common/message/errorMessage'
import { useApiError } from '@/model/api/error/apiError'
import API_URL from '@/model/api/apiUrlType'
import { LoginRedirectState } from '@/model/components/users/userLoginAuthState'

// リクエストデータ
type RequestData = {
  // ユーザー名
  username: string
  // パスワード
  password: string
}

/**
 * ログイン認証の関数を返す
 * @param store vuex
 * @returns ログイン認証の関数
 */
const useUserloginAuh = (store: Store<StoreState>) => {
  // API通信インスタンス
  const instance: AxiosInstance | undefined = instanceNoAuth(store)

  /**
   * ログイン認証のAPIを実施
   * @param state 画面データ
   * @param error エラーメッセージ状態
   * @returns true:認証成功、false:認証失敗
   */
  const post = async (state: LoginRedirectState, error: ErrorMsgState) => {
    // 戻り値
    let isNormal = true
    // リクエストデータ設定
    const request: RequestData = {
      username: state.username,
      password: state.password,
    }
    // 認証後のaxiosインスタンス取得
    const obj = instance
    await obj
      .post(
        API_URL.USERS.AUTH, // URL
        request // リクエストデータ
      )
      .then(() => {
        // 成功時は何もしない
        isNormal = true
      })
      .catch(async (e: AxiosError<ErrorResponse>) => {
        // 異常時はエラーメッセージを設定する
        await useApiError().setbaseError(e, error)
        isNormal = false
      })
    return {
      isNormal,
    }
  }
  return {
    instance,
    post,
  }
}

export { useUserloginAuh }
